var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSheetsSaved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.543 25.788s-4.973-4.912-4.973-12.28C18.57 6.14 24.786 0 24.786 0S31 6.14 31 13.508c0 7.368-6.214 12.28-6.214 12.28",
    fill: "#4EAF4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.857 13.997c-.947 1.358-2.023 3.474-2.822 4.874.005-2.005.008-3.998.01-5.93.677-1.152 1.297-2.316 1.698-3.614.031-.102-.055-.516-.173-.286-.468.913-1.032 1.745-1.524 2.627l.002-4.612c0-.25-.217-.406-.252-.07a199.88 199.88 0 0 0-.676 8.53c-.567-1.242-.663-2.65-1.259-3.882-.085-.175-.151.119-.136.19.359 1.777.41 3.634 1.211 5.301l.085.115a268.242 268.242 0 0 0-.21 4.738c-.694-1.636-1.525-3.163-2.471-4.69-.107-.17-.149.307-.12.38.826 2.077 1.588 4.163 2.478 6.213l.048.071a245 245 0 0 0-.106 8.758c.014 1.744 1.268 1.704 1.293-.032.053-3.594.081-7.724.095-11.888 1.112-2.144 2.224-4.272 2.92-6.598.012-.038-.021-.294-.091-.195z",
    fill: "#726242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.972 25.788S0 20.876 0 13.508C0 6.14 6.215 0 6.215 0s6.215 6.14 6.215 13.508c0 7.368-6.215 12.28-6.215 12.28",
    fill: "#4EAF4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.287 13.997c-.947 1.358-2.024 3.474-2.823 4.874.005-2.005.008-3.998.01-5.93.678-1.152 1.298-2.316 1.699-3.614.031-.102-.056-.516-.173-.286-.469.913-1.032 1.745-1.524 2.627l.002-4.612c0-.25-.218-.406-.253-.07a199.997 199.997 0 0 0-.676 8.53c-.566-1.242-.662-2.65-1.258-3.882-.085-.175-.152.119-.136.19.359 1.777.41 3.634 1.21 5.301l.086.115a268.242 268.242 0 0 0-.21 4.738c-.694-1.636-1.526-3.163-2.472-4.69-.106-.17-.148.307-.12.38.826 2.077 1.589 4.163 2.479 6.213l.048.071c-.088 3.07-.127 6.06-.106 8.758.014 1.744 1.267 1.704 1.293-.032.053-3.594.08-7.724.095-11.888 1.111-2.144 2.224-4.272 2.92-6.598.012-.038-.022-.294-.091-.195z",
    fill: "#726242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.254 25.788S9.28 20.876 9.28 13.508C9.281 6.14 15.497 0 15.497 0s6.214 6.14 6.214 13.508c0 7.368-6.214 12.28-6.214 12.28",
    fill: "#7CD97F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.568 13.997c-.947 1.358-2.023 3.474-2.822 4.874.004-2.005.008-3.998.01-5.93.677-1.152 1.297-2.316 1.698-3.614.031-.102-.055-.516-.173-.286-.469.913-1.032 1.745-1.524 2.627l.002-4.612c0-.25-.218-.406-.252-.07a199.88 199.88 0 0 0-.676 8.53c-.567-1.242-.663-2.65-1.259-3.882-.085-.175-.151.119-.136.19.359 1.777.41 3.634 1.211 5.301l.085.115a268.242 268.242 0 0 0-.21 4.738c-.694-1.636-1.525-3.163-2.472-4.69-.106-.17-.148.307-.12.38.827 2.077 1.59 4.163 2.479 6.213l.048.071c-.088 3.07-.127 6.06-.106 8.758.014 1.744 1.268 1.704 1.293-.032.053-3.594.081-7.724.095-11.888 1.112-2.144 2.224-4.272 2.92-6.598.012-.038-.021-.294-.091-.195z",
    fill: "#726242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetsSaved);
export default __webpack_public_path__ + "static/media/sheetsSaved.e05d674929c8e0bd048928f037af0697.svg";
export { ForwardRef as ReactComponent };